import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'

import { useWizzardHeader } from '../../context/WizzardHeaderContext'

export interface WizzardHeaderContentProps extends GridProps { }

export const WizzardHeaderContent = ({
  children,
}: WizzardHeaderContentProps) => {
  const { isScrolled } = useWizzardHeader()

  return (
    <Grid
      sx={{
        gap: { base: 4, xl: isScrolled ? 4 : 12 },
        gridTemplateColumns: {
          base: '1fr',
          md: '1fr auto',
        },
        alignContent: 'start',
        alignItems: 'start',
        justifyContent: 'space-between',
        transition: 'all 200ms ease-in-out',
      }}
    >
      {children}
    </Grid>
  )
}

WizzardHeaderContent.displayName = 'WizzardHeaderContent'
